(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hover-infographic"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
  if(window.innerWidth <= 798) {
    document.querySelectorAll('.feature-box').forEach(box => {
      box.addEventListener('click', () => {
        
        box.classList.toggle('tapped');
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__card-fan"] && !Shopify.designMode) return;
  try {
    


document.querySelectorAll('.first-card').forEach(firstCard => {
    firstCard.addEventListener('mouseover', function() {
      console.log("first card exists")
        let cards = this.parentNode.querySelectorAll('.fan-card'); // Updated to select elements with the 'fan-card' class
        cards.forEach((card, index) => {
            card.style.transform = `translateY(-20px) rotate(calc(var(--rotation) * ${index + 1}))`;
        });
    });

    firstCard.addEventListener('mouseout', function() {
        let cards = this.parentNode.querySelectorAll('.fan-card'); // Updated to select elements with the 'fan-card' class
        cards.forEach(card => {
            card.style.transform = 'none';
        });
    });
});
  

  } catch(e) { console.error(e); }
})();
})();
